import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import CopyPastePopUp from '../PopOverCopyPaste/CopyPastePopUp';
import './TruncatedTextMagnifierCell.css';

/**
 * Single-line cell: full value with CSS ellipsis when it overflows the column width (not a character count).
 * A fixed-width trailing slot is always reserved so the magnifier stays inside the cell and aligns down the column.
 */
const TruncatedTextMagnifierCell = ({ text }) => {
  const spanRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const measure = useCallback(() => {
    const el = spanRef.current;
    if (!el) return;
    setIsTruncated(el.scrollWidth > el.clientWidth + 0.5);
  }, [text]);

  useLayoutEffect(() => {
    measure();
    const el = spanRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [measure, text]);

  const display = text ?? '';

  return (
    <div className="truncated-text-magnifier-cell">
      <span ref={spanRef} className="truncated-text-magnifier-cell__text">
        {display}
      </span>
      <span className="truncated-text-magnifier-cell__icon-slot" aria-hidden={!isTruncated}>
        {isTruncated ? <CopyPastePopUp jobRef={display} /> : null}
      </span>
    </div>
  );
};

export default TruncatedTextMagnifierCell;
